import { useTranslation } from 'react-i18next';

/**
 * The attribute table's one and only column header — "Pre-enrichment /
 * Enriched / Delivered" stated once above the list, not repeated per
 * attribute. Column widths mirror `ATTRIBUTE_ROW_GRID` in
 * `delivery-compare-attribute-row.tsx` (kept as literal classes, not a shared
 * constant, since Tailwind can't compose a responsive prefix onto an
 * already-built class string). Hidden below `md`, where each row shows its
 * own inline label next to the stacked value instead — there are no
 * side-by-side columns to head at that width.
 */
export function DeliveryCompareTableHeader() {
  const { t } = useTranslation('catalog-operations');
  return (
    <div
      className="hidden border-b pb-2 md:grid md:grid-cols-3 md:gap-x-6"
      data-testid="delivery-compare-attribute-table-header"
    >
      <ColumnTitle text={t('deliveryCompare.attributeTable.preEnrichment')} />
      <ColumnTitle text={t('deliveryCompare.attributeTable.enriched')} />
      <ColumnTitle text={t('deliveryCompare.attributeTable.delivered')} />
    </div>
  );
}

function ColumnTitle({ text }: { text: string }) {
  return <p className="text-muted-foreground text-xs font-medium">{text}</p>;
}
